import type { CasAssignmentDtoT } from '@mathflat/domain/@entities/(Content)/Cas'

import maxios from '../utils/maxios'

export const casApi = (() => ({
  getHomeworks: (studentId: string, range?: { startDate?: string; endDate?: string }) => {
    return maxios.get<CasAssignmentDtoT.AssignedCasWithHomework[]>(
      `/cas/assignments/students/${studentId}/homeworks`,
      { params: range },
    )
  },
  getAssignment: (assignedId: number) => {
    return maxios.get<CasAssignmentDtoT.AssignedCasDetail>(`/cas/assignments/${assignedId}`)
  },
  getScoringList: (assignedId: number) => {
    return maxios.get<CasAssignmentDtoT.AssignedCasScoringItem[]>(
      `/cas/assignments/${assignedId}/problem`,
    )
  },
  submit: (assignedId: number, body: CasAssignmentDtoT.CasSubmitRequest) => {
    return maxios.post<CasAssignmentDtoT.CasSubmitResponse>(
      `/cas/assignments/${assignedId}/submit`,
      body,
    )
  },
}))()
